import { render, staticRenderFns } from "./TestPackageSingle.vue?vue&type=template&id=26378216"
import script from "./TestPackageSingle.vue?vue&type=script&lang=js"
export * from "./TestPackageSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports